import { createSelector } from 'reselect';
import get from 'lodash/get';

export const settingsSelector = state => state.board.settings;

export const lastUserIdSelector = createSelector(
  settingsSelector,
  settings => get(settings, 'lastUserId', null),
);

export const lastSocialIdSelector = createSelector(
  settingsSelector,
  settings => get(settings, 'lastSocialId', null),
);

export const limitSelector = createSelector(
  settingsSelector,
  settings => get(settings, 'limit', null),
);

export const offsetSelector = createSelector(
  settingsSelector,
  settings => get(settings, 'offset', null),
);

export const excludedIdsSelector = createSelector(
  settingsSelector,
  settings => get(settings, 'excludedIds', []),
);



// WEBPACK FOOTER //
// ./src/redux/board/selectors/settings.js